import { render, staticRenderFns } from "./BeaconAddEditView.vue?vue&type=template&id=47096ad2&"
import script from "./BeaconAddEditView.vue?vue&type=script&lang=js&"
export * from "./BeaconAddEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports